const DIALOGS = [];

const FOCUSABLE = (function()
{
	let a = ':not([disabled])';			// Disabled elements
	let b = ':not([tabIndex^="-"])';	// Negative tabIndex elements
	let c = ':not([type="hidden"])';	// Hidden input elements
	return [
		'a[href]' + b,
		'area[href]' + b,
		'input' + c + a + b,
		'select' + a + b,
		'textarea' + a + b,
		'button' + a + b,
		'iframe',
		'[tabIndex]' + b
	].join(', ');
})();

const getFocusableElements = function(node)
{
	return node.querySelectorAll(FOCUSABLE);
};

const createNode = function(html)
{
	/* Raiz deve ser fluxo (ex.: div), não <button>: msgbox pode conter <div>, <table>, etc.
	   HTML5 não permite blocos/tabelas dentro de <button>; o parser descartava nós e o modal ficava vazio. */
	let node = document.createElement('div');
	node.className = 'dialog';
	node.setAttribute('role', 'dialog');
	node.setAttribute('aria-modal', 'true');
	node.innerHTML = html;
	document.body.appendChild(node);
	return node;
};

const captureEvents = function(dialog)
{
	['keydown', 'click'].forEach(type => dialog.node.addEventListener(type, (ev) => eventHandler.call(dialog, ev)));
};

const eventHandler = function(ev)
{
	switch (ev.type)
	{
		case 'keydown':
			trapFocus.call(this, ev);
			keyHandler.call(this, ev);
			break;
		case 'click':
			clickHandler.call(this, ev);
			break;
	}
};

const trapFocus = function(ev)
{

	if (ev.key != 'Tab')
		return;

	let focusable_elements = getFocusableElements(this.node);	// Get a fresh list everytime because new controls can be dinamically added to the dialog
	let first_focusable_element = focusable_elements[0];
	let last_focusable_element = focusable_elements[focusable_elements.length - 1];
	let current_focus = document.activeElement;

	if (ev.shiftKey)		// Shift-Tab
	{
		if (current_focus == first_focusable_element)
		{
			ev.preventDefault();		// Prevent default action when we set the focus ourselves and let the system do its thing at all other times
			last_focusable_element.focus();
		}
	}
	else
	{
		if (current_focus == last_focusable_element)
		{
			ev.preventDefault();		// Same here
			first_focusable_element.focus();
		}
	}

};

const keyHandler = function(ev)
{
	let is_key_expected = this.re_keys.test(ev.key);
	if (is_key_expected && this.callback)
	{
		let is_button = ev.target.nodeName == 'BUTTON' && ev.target.className != 'dialog';		// Ignore inputs on our "button" background of class "dialog"
		let is_enter = ev.key == 'Enter';
		if (is_enter)					// Enter triggers actions on different elements
		{
			ev.preventDefault();		// Prevent such actions from happening automatically
			if (is_button)				// If Enter pressed over a button, act as if it is a click
				clickHandler.call(this, ev);
			else
				this.callback.call(this, ev.key, ev.target);
		}
		else
		{
			this.callback.call(this, ev.key, ev.target);
		}
	}
};

const clickHandler = function(ev)
{
	let el = ev.target;
	while (el && el !== this.node)
	{
		const className = typeof el.className === 'string' ? el.className : '';
		const matches = className.match(this.re_clicks);
		if (matches && this.callback)
		{
			ev.preventDefault();
			this.callback.call(this, matches[1], el);
			return;
		}
		el = el.parentElement;
	}
};

const dialog = {

	id: null,
	node: null,
	re_keys: /./,
	re_clicks: /\bbn_([^\b\s]+)\b/,
	callback: null,
	last_focus: null,

	create(html, callback, re_keys, re_clicks)
	{

		let dialog = Object.create(this);

		dialog.id = Symbol();
		dialog.callback = callback;
		dialog.re_keys = re_keys || dialog.re_keys;
		dialog.re_clicks = re_clicks || dialog.re_clicks;
		dialog.last_focus = document.activeElement;
		dialog.node = createNode(html);

		getFocusableElements(dialog.node)[0]?.focus();
		captureEvents(dialog);
		DIALOGS.push(dialog);

		return dialog;

	},

	destroy()
	{
		// Blindagem: destroy duplo (ex. loading + notify) não pode remover outro dialog da pilha.
		try
		{
			if (this.node?.parentNode)
				this.node.parentNode.removeChild(this.node);
		}
		catch (_) { /* já removido */ }

		let index = DIALOGS.findIndex(dialog => dialog.id == this.id);
		if (index < 0)
			return;

		if (index == DIALOGS.length - 1)						// If this is the topmost dialog, restore focus to the previous element
			this.last_focus?.focus?.();
		else
			DIALOGS[index + 1].last_focus = this.last_focus;	// The next dialog in the chain points to the removed link's previous focus

		DIALOGS.splice(index, 1);

	},

	getNode()
	{
		return this.node;
	},

};

export default dialog;

